import { FC, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import classNames from 'classnames';
import { Children, ClassName, ModalProps } from '../../../constants/types/prop.types.ts';

export type EmptyModalProps = Partial<ClassName> & ModalProps & Partial<Children>;

const EmptyModal: FC<EmptyModalProps> = ({ open, onClose, children, className }) => (
  <Transition appear show={open} as={Fragment}>
    <Dialog as="div" className="relative z-[1000]" onClose={onClose}>
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-black bg-opacity-80" />
      </Transition.Child>

      <div className="fixed inset-0 min-h-[100dvh] overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 ">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel
              className={classNames(
                'relative w-full max-w-[560px] transform overflow-hidden rounded-md bg-white',
                'p-[32px] text-left align-middle shadow-xl transition-all',
                className,
              )}
            >
              {children}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition>
);

export default EmptyModal;
